var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('lab-task',[_c('lab-new-density-of-liquids-and-solids',{attrs:{"density-of-unknown-liquid":_vm.liquidDensity,"density-of-metal":_vm.solidDensity},on:{"allGuidanceComplete":_vm.submitResponse}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }